import React from 'react';
import { FileText, AlertCircle } from 'lucide-react';
import { BACKEND_URL } from '../../api';

const API_LINKS_META = [
  {
    title: 'Swagger UI',
    desc: 'Interfaccia interattiva per esplorare e testare gli endpoint REST. Adatta a sviluppatori e integrazioni.',
    path: '/api/docs',
    color: 'border-emerald-200 bg-emerald-50 hover:bg-emerald-100',
    iconColor: 'text-emerald-600',
  },
  {
    title: 'ReDoc',
    desc: 'Documentazione API navigabile in formato leggibile (read-only). Utile per panoramica e PDF print.',
    path: '/api/redoc',
    color: 'border-blue-200 bg-blue-50 hover:bg-blue-100',
    iconColor: 'text-blue-600',
  },
  {
    title: 'OpenAPI Spec (JSON)',
    desc: 'Schema OpenAPI 3.0 raw. Importa in Postman, Insomnia o genera client SDK.',
    path: '/api/openapi.json',
    color: 'border-slate-200 bg-slate-50 hover:bg-slate-100',
    iconColor: 'text-slate-600',
  },
];

export default function ApiDocsTab() {
  const baseUrl = BACKEND_URL || '';
  const links = API_LINKS_META.map(l => ({ ...l, url: `${baseUrl}${l.path}` }));

  return (
    <div className="space-y-6" data-testid="api-docs-tab">
      <div className="bg-gradient-to-r from-primary to-amber-50 border border-primary rounded-md p-5">
        <h3 className="text-lg font-black text-slate-900 mb-2">Documentazione API REST</h3>
        <p className="text-sm text-slate-700">
          Tutti gli endpoint del backend EDILCIMA sono documentati in formato OpenAPI 3.0.
          Auth: <code className="px-1.5 py-0.5 bg-white border rounded text-xs">Authorization: Bearer &lt;token&gt;</code> oppure cookie httpOnly.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {links.map((l) => (
          <a
            key={l.title}
            href={l.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`block border-2 rounded-md p-5 transition-colors ${l.color}`}
            data-testid={`api-link-${l.title.toLowerCase().replace(/[^a-z]/g, '-')}`}
          >
            <div className="flex items-start gap-3 mb-3">
              <FileText className={`flex-shrink-0 mt-0.5 ${l.iconColor}`} size={22} />
              <div>
                <h4 className="font-black text-slate-900">{l.title}</h4>
                <p className="text-xs text-slate-500 truncate">{l.path}</p>
              </div>
            </div>
            <p className="text-sm text-slate-700 leading-relaxed">{l.desc}</p>
          </a>
        ))}
      </div>

      <div className="bg-slate-50 border border-slate-200 rounded-md p-5">
        <h4 className="font-bold text-slate-900 mb-2 flex items-center gap-2">
          <AlertCircle size={16} className="text-amber-600" /> Quick reference
        </h4>
        <ul className="text-sm text-slate-700 space-y-1.5">
          <li>• <strong>Login:</strong> <code className="px-1.5 py-0.5 bg-white border rounded text-xs">POST /api/auth/login</code> con <code className="px-1.5 py-0.5 bg-white border rounded text-xs">{'{email, password}'}</code> → restituisce <code className="px-1.5 py-0.5 bg-white border rounded text-xs">token</code></li>
          <li>• <strong>AI async:</strong> i job AI ritornano <code className="px-1.5 py-0.5 bg-white border rounded text-xs">202 + job_id</code>; pollare <code className="px-1.5 py-0.5 bg-white border rounded text-xs">GET /api/ai/jobs/{'{id}'}</code> fino a <code className="px-1.5 py-0.5 bg-white border rounded text-xs">status:"done"</code></li>
          <li>• <strong>Report Excel Geppo:</strong> <code className="px-1.5 py-0.5 bg-white border rounded text-xs">GET /api/assistant/report/excel/{'{tipo}'}</code> dove tipo ∈ preventivi|fatture|spese|clienti|cantieri|contabilita_mensile</li>
          <li>• <strong>Reference completo:</strong> <code className="px-1.5 py-0.5 bg-white border rounded text-xs">/app/memory/API_REFERENCE.md</code> nel codebase</li>
        </ul>
      </div>
    </div>
  );
}
